import React from 'react'; 
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import constants from 'utils/constants'
import {formatCommentDate} from 'utils/utils';

import optionIcon from 'images/icon/dot_icon_light_grey-8x36.png';

export default function CommentItem({
	comment, wrapperStyle,
	showAddComment=true, showOption=false,
	onClickAddComment, onClickOption, onClickLikeComment, onClickUnlikeComment
}) {
	
	return (
		<>
		{comment && 
			<ItemWrapper style={wrapperStyle}>
				<Link to={`/task/friend/${comment?.user_no}/list`}>
					<ProfileWrapper>
						<ProfileImg src={`${constants.imagePath}/user_profile_img/${comment['profile_img']}`}/>
					</ProfileWrapper>
				</Link>
				<CommentBodyWrapper>
				<BodyTop><UserName>{comment['nickname']}</UserName><CommentContent>{comment['content']}</CommentContent></BodyTop>
				<BodyBottom>
				<CreateDate>{`${formatCommentDate(comment['create_date'])} 전`}</CreateDate>
				<LikeBtn isLike={comment['liked_comment']} onClick={
					(e)=>{
						if(comment['liked_comment'] === true)
						{
							if(onClickUnlikeComment)
							{
								onClickUnlikeComment(comment['no'])
							}
						}
						else
						{
							if(onClickLikeComment)
							{ 
								onClickLikeComment(comment['no'])
							}
						} 
					}}>
				좋아요
				{parseInt(comment['total_like']) > 0 && comment['total_like']}
				</LikeBtn>
				{(showAddComment) && (<AddCommentBtn onClick={()=>{if(onClickAddComment)onClickAddComment()}}>답글달기</AddCommentBtn>)}
				</BodyBottom>
				</CommentBodyWrapper> 
				{(showOption) && (<OptionBtnWrapper onClick={()=>{if(onClickOption)onClickOption(comment['no'])}}><OptionBtnIcon src={optionIcon}/></OptionBtnWrapper>)}
			</ItemWrapper>
		}
		</>
		);
}
export const ItemWrapper = styled.div`
position:relative;
display: flex;
max-width: 100%;
`
export const ProfileWrapper = styled.div`
min-width: calc(100vw*(28/375));
min-height: calc(100vw*(28/375));
width: calc(100vw*(28/375));
height: calc(100vw*(28/375));
border: 1px solid #C4C4C4;
border-radius : 100%;
overflow : hidden;
flex : 0 1 auto;

margin-right : calc(100vw*(6/375));
`
export const ProfileImg = styled.img`
width: 100%;
height: 100%;
object-fit: cover;
`
export const CommentBodyWrapper = styled.div`
flex: 1 1 auto;
width : 100%;
` 
export const BodyTop = styled.div`
word-break: break-all;

margin-bottom : calc(100vw*(3/375));
`
export const UserName = styled.span`
font-style: normal;
font-weight: bold;
font-size: calc(100vw*(14/375));
color: #121212;
margin-right : calc(100vw*(10/375));
`;
export const CommentContent = styled.span`
font-style: normal;
font-weight: normal;
font-size: calc(100vw*(14/375));
color: #121212;
white-space: pre-wrap;
`;
export const BodyBottom = styled.div``
export const CreateDate = styled.span`
font-style: normal;
font-weight: 500;
font-size: calc(100vw*(11/375));
color: #989898;
margin-right : calc(100vw*(10/375));
`
export const LikeBtn = styled.span`
font-style: normal;
font-weight: 500;
font-size: calc(100vw*(11/375));
color: ${({isLike}) => isLike ? '#FF9B57' : '#989898'};
margin-right : calc(100vw*(14/375));
`
export const UnLikeBtn = styled(LikeBtn)`
color: #989898;
`

export const AddCommentBtn = styled.span`
font-style: normal;
font-weight: bold;
font-size: calc(100vw*(11/375));
color: #989898;
`
export const OptionBtnWrapper = styled.div`
width : calc(100vw*(4/375));
height : calc(100vw*(18/375));
min-width : calc(100vw*(4/375));
min-height : calc(100vw*(18/375));
padding-top: calc(100vw*(3/375));
padding-left: calc(100vw*(12/375));
padding-right: calc(100vw*(17/375));    
box-sizing: border-box;
flex: 0 1 auto;
`;
export const OptionBtnIcon = styled.img`
width: calc(100vw*(4/375));
height: calc(100vw*(18/375)); 
`